/**
 * Generates a CSV string from rows of data and triggers a browser download.
 */
export const downloadCsv = (filename: string, headers: string[], rows: string[][]): void => {
  const escapeString = (val: string): string => {
    if (val.includes(',') || val.includes('"') || val.includes('\n')) {
      return `"${val.replace(/"/g, '""')}"`
    }
    return val
  }

  const lines = [headers.map(escapeString).join(','), ...rows.map((row) => row.map(escapeString).join(','))]

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
